import { FetchAuth } from "../utils/FetchAuthUtil";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class ReportsService {
    // Get yearly access code usage per school
    public static getYearlyAccessCodePerSchool = async (
        
        schoolId: string,
        bookId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerSchool/${schoolId}/${bookId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
            

            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    // Get yearly access code usage per batch
    public static getYearlyAccessCodePerBatch = async (
        
        batchId: string,
        bookId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerBookByBatch/${bookId}/${batchId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
     
            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    public static getYearlyAccessCodePerBook = async (
        bookId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerBook/${bookId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
     
            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    public static getYearlyAccessCodePerBookWebsite = async (
        bookId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerBookOnline/${bookId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
     
            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    // Get access code usage per publisher
    public static getAccessCodeUsagePerPublisher = async (
        
        publisherId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerPublisher/${publisherId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
       

            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    public static getAccessCodeUsagePerPublisherWebsite = async (
        
        publisherId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerPublisherOnline/${publisherId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
       

            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };
    // Get access code usage per batch
    public static getAccessCodeUsagePerBatch = async (
        
        batchId: string,
        year: string
    ): Promise<any> => {
        try {
            const resp = await FetchAuth(
                `${endpoint}/admin/getAccessCodeUsagePerBatch/${batchId}?year=${year}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
    
            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    // Get top downloaded books with filters
    public static getTopDownloadedBooks = async (
        
        page: number,
        limit: number,
        name: string,
        publisherId?: string,
        categoryId?: string,
        type?: string,
        sortColumn?:string|null,
        sortDirection?:string,
    ): Promise<any> => {
        try {
            const queryParams = new URLSearchParams({
                page: String(page),
                limit: String(limit),
                ...(publisherId !== undefined && { publisherId: String(publisherId) }),
                ...(categoryId !== undefined && { categoryId: String(categoryId) }),
                ...(type && { type: type }),
                ...(name && { name: name }),
            });
            if(sortColumn&&sortDirection){
                queryParams.append("sort",`${sortColumn}:${sortDirection}`)
                
            }


            const resp = await FetchAuth(
                `${endpoint}/admin/getTopDownloadedBooks?${queryParams.toString()}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': "application/json",
                    },
                }
            );
            
            

            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    public static getSalesByPublisher=async(publisherId:string,year:string)=>{
        try {
            const resp = await FetchAuth(
                `${endpoint}/order/getPublisherAnalytics`,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': "application/json",
                    },
                    body:JSON.stringify({publisherId,year})

                }
            );
            const data = await resp.json();
            return data;
        } catch (error) {
            console.log(error)
        }
    }
}
